// extracted by mini-css-extract-plugin
module.exports = {"title":"Newsletter_title__I8Mqt","group":"Newsletter_group__JpG9b","input":"Newsletter_input__3socT","button":"Newsletter_button__atuwY"};